export const MAX_PARENTS_DATA_ITEMS_COUNT = 2;
